import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { ContextService } from '../services/ctx.service';
import { StateService } from '../services/state.service';

@Injectable({
    providedIn: 'root'
})
export class NoDirectAccessGuard implements CanActivate, CanActivateChild {
    constructor(
        private ctx: ContextService,
        private stateService: StateService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return directAccesGuard(route, this.ctx, this.router, this.stateService);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return directAccesGuard(route, this.ctx, this.router, this.stateService);
    }
}

export const directAccesGuard = (
    route: ActivatedRouteSnapshot,
    ctx: ContextService,
    router: Router,
    stateService: StateService) => {
    if (!ctx.isFirstPage$.getValue()) {
        return true;
    }
    const state = stateService.getStateValue();
    const path = state?.userIdentified ?'/home' :'/doctors-centers'
    router.navigate([path]);
    return false;
};
